import {ReactElement, ReactNode} from 'react';
import MemorizedJudgeMePreloader from '../lib/MemorizedJudgeMePreloader.client';

interface LayoutProps {
  children?: ReactNode;
}

export function Layout({children}: LayoutProps): ReactElement {
  return (
    <>
      {children}
      <MemorizedJudgeMePreloader />
    </>
  );
}
